module.exports = __webpack_public_path__ + "img/blog-dp-photo-corners-settings.9e5779a5.webp";